import { useNavigate } from "react-router-dom";
import { useAuthContext } from "../Context/LoginSignupContext";

const Islogin = () => {
  const navigate = useNavigate();
  const {
    setLoginTrue,
    setIsAdmin,
    setLoginFalse,
    setUsername,
    setLoginLoading,
  } = useAuthContext();
  try {
    let params = window.location.search.split("token=")[1];

    if (params) {
      localStorage.setItem("token", params);
      navigate("/");
    }
    let token = params || localStorage.getItem("token") || null;
    if (token) {
      fetch(`${process.env.REACT_APP_BASE_URL}/islogin`, {
        method: "GET",
        headers: {
          "auth-token": token,
        },
      })
        .then((res) => res.json())
        .then((data) => {
          setLoginLoading(false);
          console.log("eeeeeeeeeeeeeeee");
          if (data.username) {
            if (data.email === "c@gmail.com") {
              setIsAdmin(true);
            }

            console.log(data);
            setUsername(data.username.split(" ")[0]);

            setLoginTrue();
          } else {
            setTimeout(() => {
              setLoginFalse();
            }, 0);
          }
          setLoginLoading(false);
        });
    } else {
      setLoginFalse();
      setLoginLoading(false);
    }
  } catch (error) {
    console.log("error from checking is login", error);
  }
};

export default Islogin;
